var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{attrs:{"appData":_vm.$appData}},[_c('template',{slot:"pageContent"},[_c('loader',{attrs:{"loading":_vm.loading}},[_c('notification-settings',{attrs:{"actionCode":_vm.code},on:{"error":_vm.openNotificationSettings}})],1)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }